import { useRbacStore } from './store'

export function permissionCovers(requiredKey: string, userPermission: string): boolean {
  const r = requiredKey.trim()
  const p = userPermission.trim()
  if (!r || !p) return false
  if (p === r) return true
  if (p.endsWith(':*')) {
    const prefix = p.slice(0, -2)
    return r === prefix || r.startsWith(prefix + ':')
  }
  return p.startsWith(r + ':')
}

export function hasPermissionForKey(requiredKey: string, userPermissions: string[]): boolean {
  const k = requiredKey?.trim()
  if (!k) return true
  const list = userPermissions ?? []
  return list.some((p) => permissionCovers(k, p.trim()))
}

export function useHasPermission(keys: string | string[]): boolean {
  const whitelistMode = useRbacStore((s) => s.whitelistMode)
  if (whitelistMode) return true
  const keyList = Array.isArray(keys) ? keys : [keys]
  if (!keyList.length) return true
  const uiPermissionKeys = useRbacStore((s) => s.uiPermissions)
  const list = uiPermissionKeys ?? []
  return keyList.some((k) => k && hasPermissionForKey(k, list))
}
